<template>
  <v-card-actions>
    <ConfirmationDialog ref="confirm" :function-yes="bindingFunction"></ConfirmationDialog>
    <SubsanarDialog ref="subsanar"></SubsanarDialog>
    <v-btn :disabled="(!estadoPermissions.canApprove) || loading" color="#1787c9" class="white--text"
           @click="aprobar">Aceptar</v-btn>
    <v-btn :disabled="(!estadoPermissions.canCorrect) || loading" color="#1787c9" class="white--text"
           @click="subsanar">A Subsanar</v-btn>
  <!--  <v-btn :disabled="(!estadoPermissions.canOpenCaseFile) || loading" color="#1787c9" class="white--text"
           @click="abrirExpediente">Abrir Expediente</v-btn>-->
  </v-card-actions>
</template>

<script>
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import SubsanarDialog from '../components/SubsanarDialog'

export default {
  props: {
    estadoPermissions: Object
  },
  components: {
    ConfirmationDialog,
    SubsanarDialog
  },

  data () {
    return {
      loading: false,
      bindingFunction: null
    }
  },

  methods: {
    aprobar () {
      this.bindingFunction = () => {
        this.loading = true
        this.axios
          .put(`/presentaciones/aprobar/${this.$route.params.id}`)
          .then(() => {
            this.loading = false
            this.$router.push({ name: 'presentaciones' })
          })
          .catch(error => {
            this.loading = false
            this.$store.commit('setErrorMsg', error)
          })
      }
      this.$refs.confirm.openDialog()
    },
    subsanar () {
      this.$refs.subsanar.openDialog()
    },
    abrirExpediente () {
      this.bindingFunction = () => {
        this.loading = true
        this.axios
          .put(`/presentaciones/open-case-file/${this.$route.params.id}`)
          .then(() => {
            this.loading = false
            this.$router.push({ name: 'presentaciones' })
          })
          .catch(error => {
            this.loading = false
            this.$store.commit('setErrorMsg', error)
          })
      }
      this.$refs.confirm.openDialog()
    }
  }
}
</script>
